import { Card, CardContent } from "@/components/ui/card";
import { Mic, Users, Building2, FileCheck } from "lucide-react";

const features = [
  {
    icon: Mic,
    title: "AI Medical Scribe",
    description:
      "Ambient AI listens to patient encounters and generates structured clinical notes in real time. Supports SOAP, H&P, and custom templates across specialties.",
  },
  {
    icon: Users,
    title: "Team Collaboration",
    description:
      "Share notes, assign reviews, and coordinate care across your provider network. Role-based access keeps PHI secure while enabling seamless handoffs.",
  },
  {
    icon: Building2,
    title: "Multi-Provider Workflows",
    description:
      "Designed for group practices and health networks. Each provider gets personalized preferences while administrators get unified oversight and analytics.",
  },
  {
    icon: FileCheck,
    title: "EHR Integration",
    description:
      "One-click sync with Epic, Cerner, athenahealth, and 30+ other EHR systems. Notes flow directly into the patient chart — no copy-paste, no double entry.",
  },
];

export function Features() {
  return (
    <section
      id="features"
      className="py-20 lg:py-28 bg-gradient-to-b from-slate-50 to-white scroll-mt-16"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-sm font-semibold uppercase tracking-widest text-brand-red mb-3">
            Features
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-brand-navy mb-4">
            Everything Your Care Team Needs
          </h2>
          <p className="text-lg text-slate-500 leading-relaxed">
            From ambient AI transcription to network-wide analytics, ConsultNow
            streamlines documentation for every provider.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          {features.map((feature) => (
            <Card
              key={feature.title}
              className="glass rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-white/80"
            >
              <CardContent className="p-7">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-brand-navy/10 to-brand-red/10 flex items-center justify-center mb-5">
                  <feature.icon className="h-6 w-6 text-brand-navy" />
                </div>
                <h3 className="text-lg font-semibold text-brand-navy mb-3">
                  {feature.title}
                </h3>
                <p className="text-sm text-slate-500 leading-relaxed">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
